export default __webpack_public_path__ + "static/media/4.1d9a07f4.jpg";